import { useEffect, useState } from "react";
import type { Locale } from "./homepage-seo";
import copy from "../content/analytics-consent.json";
import { analyticsContextPermitted, getAnalyticsConsent, setAnalyticsConsent, subscribeAnalyticsConsent } from "./analytics-consent";
import "./analytics-consent.css";

/** Inline footer control: never overlays a primary action or blocks navigation. */
export function AnalyticsConsent({ locale }: { locale: Locale }) {
  const [choice, setChoice] = useState(getAnalyticsConsent);
  const [editing, setEditing] = useState(false);
  const text = copy[locale] || copy.en;
  useEffect(() => subscribeAnalyticsConsent(() => {
    setChoice(getAnalyticsConsent());
    setEditing(false);
  }), []);
  if (!analyticsContextPermitted()) return null;
  if (choice !== "unknown" && !editing) return (
    <div className="analytics-preferences">
      <button type="button" onClick={() => setEditing(true)}>{text.preferences}</button>
    </div>
  );
  return (
    <section className="analytics-consent" aria-label={text.preferences}>
      <span>{text.question}</span>
      <div className="analytics-consent-actions">
        <button type="button" onClick={() => setAnalyticsConsent("granted")}>{text.allow}</button>
        <button type="button" onClick={() => setAnalyticsConsent("denied")}>{text.decline}</button>
        <a href={locale === "en" ? "/privacy" : `/${locale}/privacy`}>{text.policy}</a>
      </div>
    </section>
  );
}
